export const HOSTURL = "https://api.nbcfonline.com";
//export const HOSTURL = "http://localhost:8080";
export const STATION_AUTH_API = "/station/user/authenticate/finance/";
export const STATION_API = HOSTURL + "/stations/";
export const USER_API = HOSTURL + "/user/";
export const TOKEN_API = HOSTURL + "/tokens";
export const TOKEN_HISTORY_API = HOSTURL + "/tokenHistory/";
